<template>
  <span class="fill-height">
    <Loading :image="1" :loading="loading" />
    <div
      id="Drawing"
      class="Drawing"
      :class="loading ? 'fill-height' : 'simulator-container'"
    >
      <NavbarDrawing v-if="!loading" :is3d="true"/>
      <!-- Mesmo layout do 2D: lista de objetos | cena 3D | propriedades; em telas estreitas, barra inferior -->
      <div v-if="!loading && !compact" class="sim-layout">
        <aside class="sim-col sim-col--left">
          <SideNavSimulator :is3d="true"/>
        </aside>
        <div class="sim-col sim-col--center">
          <ThreeDrawing/>
        </div>
        <aside class="sim-col sim-col--right">
          <RightNavSimulator :is3d="true"/>
        </aside>
      </div>
      <template v-if="!loading && compact">
        <div class="compact-center">
          <ThreeDrawing/>
        </div>
        <SimulatorCompactPanels :fit="false">
          <template #left><SideNavSimulator :is3d="true"/></template>
          <template #right><RightNavSimulator :is3d="true"/></template>
        </SimulatorCompactPanels>
      </template>
      <LoadingModal/>
      <BenchmarkDialog />
      <PreviewSimulationModal :is3d="true"/>
    </div>
  </span>
</template>

<script>

import { mapActions } from "vuex";
import simulator3d from "@/services/simulator3d";
import Swal from "sweetalert2";

export default {
  name: "Simulator3d",
  components: {
    Loading: () => import("@/components/Loading"),
    NavbarDrawing: () => import("@/components/Navbar"),
    SideNavSimulator: () => import("@/components/SideNavSimulator"),
    RightNavSimulator: () => import("@/components/RightNavSimulator"),
    ThreeDrawing: () => import("@/components/ThreeDrawing"),
    LoadingModal: () => import("@/components/LoadingModal"),
    BenchmarkDialog: () => import("@/components/BenchmarkDialog"),
    PreviewSimulationModal: () => import("@/components/PreviewSimulationModal"),
    SimulatorCompactPanels: () => import("@/components/SimulatorCompactPanels"),
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    // Abaixo de 960 px (celulares e tablets em pé) as barras laterais viram painéis da barra inferior
    compact() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init: async function() {
      await simulator3d
        .get(this.$route.params.key)
        .then(response => {
          try {
            this.set3dState(response);
          } catch (err) {
            Swal.fire({
              title: "An error appears in your simulation!",
              text: err.message
            });
          }
        })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });

      document.addEventListener("keydown", this.keyPressAction);
      document.addEventListener("keyup", this.keySolveAction);
    

      this.setPageInfo();
    },
    setPageInfo: function() {
      document.title = "Simulator - ElectrosFI";
      document
        .querySelector('meta[name="description"')
        ?.setAttribute(
          "content",
          "Simulate and edit photonic tools online - ElectrosFI"
        );
    },
    ...mapActions("simulator", ["set3dState"])
  }
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
